import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "../Reveal";
import { SERVICES, SERVICE_ROUTES } from "../../data/site";

const Card = ({ s, i }) => (
  <Reveal delay={(i % 3) * 0.08} data-testid={`service-card-${s.slug}`}>
    <Link to={SERVICE_ROUTES[s.slug]} className="group block" data-testid={`service-link-${s.slug}`}>
      <div className="overflow-hidden">
        <img
          src={s.img}
          alt={s.title}
          loading="lazy"
          className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
        />
      </div>
      <div className="flex items-start justify-between gap-4 border-b border-charcoal/10 py-6">
        <div>
          <div className="flex items-baseline gap-3">
            <span className="font-heading text-[13px] font-bold tracking-[0.2em] text-bronze">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="h4 text-charcoal transition-colors duration-300 group-hover:text-bronze">{s.title}</h3>
          </div>
          <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-mute">{s.desc}</p>
          <span className="link-arrow mt-5 text-[12px]">
            Explore Service
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </span>
        </div>
      </div>
    </Link>
  </Reveal>
);

export const Services = () => (
  <section id="services" data-testid="services-section" className="section-pad bg-warm2">
    <div className="container-cando">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>What We Build</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="h2 mt-6 max-w-xl text-charcoal">Construction Services for the Way You Live.</h2>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.16}>
            <p className="body-lg max-w-md text-mute lg:ml-auto">
              From structural framing to finished interiors, Cando Construction provides practical
              construction solutions for Edmonton homeowners.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="mt-16 grid gap-x-10 gap-y-12 md:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
        {SERVICES.map((s, i) => (
          <Card key={s.slug} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
